module.exports = __webpack_public_path__ + "static/media/accountExec-female-icon.22d4513e.svg";